import React from 'react';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {
	StackCompat as Stack,
	DialogCompat as Dialog,
	DefaultButtonCompat as DefaultButton,
	PrimaryButtonCompat as PrimaryButton,
	DialogFooterCompat as DialogFooter,
	DialogType,
} from 'components/FluentUICompat';
import {useNavigate} from 'react-router-dom';
import {ActionButton} from 'components';
import {DataStoreGridChangedItems, tOptionsGrid} from './GridView';
import {options} from 'dropzone';

export enum GridDialogType {
	Save,
	SaveExit,
	Cancel,
	Recover,
	None,
}

interface IGridViewDialog {
	gridDialogType: GridDialogType;
	setgridDialogType: (gridDialogType: GridDialogType) => void;
	handleClickUpdateItems: () => Promise<void>;
	handleConfirmDataRecovery: () => void;
}

export const GridViewDialog: React.FC<IGridViewDialog> = ({
	gridDialogType,
	setgridDialogType,
	handleClickUpdateItems,
	handleConfirmDataRecovery,
}) => {
	const {t} = useTranslation(tOptionsGrid.ns, {keyPrefix: 'dialog'});

	const navigate = useNavigate();

	let dialogTile = '';
	let dialogSubText = '';
	switch (gridDialogType) {
		case GridDialogType.Save:
			dialogTile = t('titleSave');
			dialogSubText = t('textSave');
			break;

		case GridDialogType.SaveExit:
			dialogTile = t('titleSaveExit');
			dialogSubText = t('textSaveExit');
			break;

		case GridDialogType.Cancel:
			dialogTile = t('titleCancel');
			dialogSubText = t('textCancel');
			break;

		case GridDialogType.Recover:
			dialogTile = t('titleRecover');
			dialogSubText = t('textRecover');
			break;
	}

	return (
		<Dialog
			hidden={gridDialogType === GridDialogType.None}
			modalProps={{isBlocking: true}}
			onDismiss={() => {
				setgridDialogType(GridDialogType.None);
			}}
			dialogContentProps={{
				type: DialogType.normal,
				title: dialogTile,
				subText: dialogSubText,
			}}
		>
			<DialogFooter>
				{gridDialogType === GridDialogType.Save && (
					<PrimaryButton
						onClick={async () => {
							await handleClickUpdateItems();
							setgridDialogType(GridDialogType.None);
						}}
					>
						{t('ClickSave')}
					</PrimaryButton>
				)}
				{gridDialogType === GridDialogType.SaveExit && (
					<Stack
						horizontal
						horizontalAlign='space-between'
						tokens={{childrenGap: 10}}
					>
						<PrimaryButton
							onClick={async () => {
								await handleClickUpdateItems();
								navigate(0);
							}}
						>
							{t('ClickSave')}
						</PrimaryButton>
						<DefaultButton
							onClick={async () => {
								navigate(0);
							}}
						>
							{t('ClickCancel')}
						</DefaultButton>
					</Stack>
				)}
				{gridDialogType === GridDialogType.Cancel && (
					<ActionButton
						onClick={async () => {
							navigate(0);
						}}
					>
						{t('ClickCancel')}
					</ActionButton>
				)}
				{gridDialogType === GridDialogType.Recover && (
					<ActionButton
						onClick={async () => {
							handleConfirmDataRecovery();
							setgridDialogType(GridDialogType.None);
						}}
					>
						{t('ClickRecover')}
					</ActionButton>
				)}
			</DialogFooter>
		</Dialog>
	);
};
